<template>
  <div class="gewerbestep2">
    <v-row no-gutters align="end" class="semanticsection-title2 first">
      <div class="primary--text mr-8">Auswahl Produkt und Selbstbeteiligung</div>
      <div
        v-if="producterror"
        class="error--text dmb-form-text pb-1"
      >Bitte wählen Sie ein Produkt aus.</div>
      <v-spacer />
      <router-link to="/produkte/gewerbe" target="_blank">
        <div class="dmb-link pb-1">
          <span class="dmb-link-underline">Produktinfos</span>
          <v-icon class="ml-1 mb-1">open_in_new</v-icon>
        </div>
      </router-link>
    </v-row>

    <gewerbe-price-matrix @gwproduct-selected="$emit('gwproduct-selected')" />

    <!-- v-show instead of v-if because Zusatzbausteintabelle removes Deckungen from the store when they are not allowed -->
    <div v-show="showKompex">
      <div class="semanticsection-title2 primary--text">Zusatzbausteine für den gewerblichen Bereich</div>

      <zusatzbaustein-tabelle
        :items="Object.values(gewerbeZusatzbausteine)"
        person-ref="vn1"
        gewerbe
      ></zusatzbaustein-tabelle>

      <div v-show="!excludeGF">
        <div class="semanticsection-title2 primary--text">Zusatzbausteine für den privaten Bereich</div>

        <dmb-accordion
          ref="accordionStep2gf"
          :items="geschaeftsfuehrer"
          component-name="ZusatzbausteinePrivat"
          :allow-delete="!zusatzbausteineDisabled"
          state-path="gewerbe.ui.accordions.step2gf"
          @remove="removeGeschaeftsfuehrer(...arguments)"
        />

        <add-button
          text="Privat-Rechtsschutz für einen weiteren Inhaber/Geschäftsführer hinzufügen"
          @add="addGeschaeftsfuehrer()"
        ></add-button>
      </div>
    </div>

    <v-row :no-gutters="false" class="stepperbuttons">
      <v-btn color="primary" class="standard-button" @click="$emit('step-back')">Zurück</v-btn>
      <v-spacer />
      <v-btn color="primary" class="standard-button" @click="stepForward">Weiter</v-btn>
    </v-row>
    <confirm ref="confirm" />
  </div>
</template>

<script>
import { mapTwoWay } from '@/store/twowayBindingMixin';
import twowayBindingMixin from '../../store/twowayBindingMixin';
import ValidationMixin from '../helper/ValidationMixin';
import GewerbePriceMatrix from '../gewerberechner/GewerbePriceMatrix';
import AddButton from '../gewerberechner/AddButton';
import DmbAccordion from '../gewerberechner/DmbAccordion';
import ZusatzbausteinTabelle from '../gewerberechner/ZusatzbausteinTabelle';
import { mapGetters, mapState } from 'vuex';
import Zusatzbausteine from '@/store/config/gewerbeZusatzbausteine';
import confirm from '@/components/helper/confirm';

export default {
  name: 'GewerbeStep2',
  components: {
    AddButton,
    DmbAccordion,
    GewerbePriceMatrix,
    ZusatzbausteinTabelle,
    confirm
  },
  mixins: [twowayBindingMixin, ValidationMixin],
  props: {
    producterror: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      gewerbeZusatzbausteine: Zusatzbausteine.gewerbe
    };
  },
  computed: {
    zusatzbausteineDisabled() {
      return (
        this.matrixSelection.produkte.filter(p => /^SPEZ-PBV*/.test(p))
          .length === 0 || this.excludeGF
      );
    },
    geschaeftsfuehrer() {
      return this.$store.getters.geschaeftsfuehrer.map((gf, i) => {
        return {
          key: gf.key,
          label: `${i + 1}. Inhaber/Geschäftsführer`,
          name:
            gf.firstname || gf.lastname
              ? (gf.firstname || '') + ' ' + (gf.lastname || '')
              : null,
          statePath: this.$store.getters.personPath(gf.key)
        };
      });
    },
    ...mapTwoWay(['anzahl'], {}, 'gewerbe.mitarbeiter.inhaber'),
    ...mapState({
      isKompex: state => state.gewerbe.ui.isKompex,
      showKompex: state => state.gewerbe.ui.showKompex,
      matrixSelection: state => state.gewerbe.ui.matrixSelection,
      excludeGF: state => state.gewerbe.ui.excludeGF,
      activeStepNumber: state => state.s.gewerbe.activeStepNumber
    }),
    ...mapGetters(['ersterGF'])
  },
  watch: {
    activeStepNumber(newStep) {
      if (newStep === 2 && this.geschaeftsfuehrer.length === 0) {
        // first GF is free
        this.$store.commit('addGeschaeftsfuehrer');
      }
    },
    zusatzbausteineDisabled(value) {
      this.setFreeGfDeckungen(!value);
    },
    excludeGF(value) {
      if (value) {
        // delete all but the first GF
        const keys = this.$store.getters.geschaeftsfuehrer.map(
          gf => +gf.key.substring(2)
        );
        const key1 = Math.min(...keys);
        this.$store.getters.geschaeftsfuehrer.forEach(gf => {
          if (gf.key !== `gf${key1}`) this.removeGeschaeftsfuehrer(gf.key);
        });
      }
    }
  },
  methods: {
    addGeschaeftsfuehrer() {
      if (this.zusatzbausteineDisabled) {
        this.$store.dispatch('gewerbeShowKompexHint');
      } else if (this.geschaeftsfuehrer.length < 5) {
        const gfAdd = () => {
          this.$store.dispatch('gewerbeAddGeschaeftsfuehrer');
          this.$nextTick(() => {
            const index = this.geschaeftsfuehrer.length - 1;
            const ref = this.$refs['accordionStep2gf'];
            ref.scrollEffectsOff(true);
            ref.scrollIntoView(index, this.geschaeftsfuehrer[index].key);
          });
        };
        if (this.anzahl == this.geschaeftsfuehrer.length) {
          this.$refs.confirm
            .open(
              'Weiterer Inhaber/Geschäftsführer',
              `Wollen Sie einen weiteren Inhaber / Geschäftsführer hinzufügen? Die Anzahl der Inhaber / Geschäftsführer wird dadurch von ${
                this.anzahl
              } auf ${1 + this.geschaeftsfuehrer.length} erhöht.`,
              { color: 'primary' }
            )
            .then(() => {
              gfAdd();
            });
        } else {
          gfAdd();
        }
      } else {
        this.$store.dispatch('gewerbeShowMaxLimit', {
          label: 'Geschäftsführer',
          limit: 5
        });
      }
    },
    removeGeschaeftsfuehrer(key) {
      this.$store.dispatch('gewerbeRemoveGeschaeftsfuehrer', { key });
    },
    setFreeGfDeckungen(set) {
      if (!this.ersterGF) return;
      if (set) {
        this.$store.dispatch('gewerbeAddZusatzDeckung', {
          person: this.ersterGF.key,
          produkt: 'SPEZ-PRIV',
          sb: this.matrixSelection.sb,
          isFree: true
        });
      } else {
        this.$store.dispatch('gewerbeRemoveZusatzDeckung', {
          person: this.ersterGF.key,
          produkt: 'SPEZ-PRIV'
        });
      }
    },
    stepForward() {
      if (
        this.isKompex &&
        this.anzahl > this.geschaeftsfuehrer.length &&
        this.geschaeftsfuehrer.length < 5
      ) {
        this.$refs.confirm
          .open(
            'Weitere Inhaber/Geschäftsführer',
            `Das Unternehmen hat ${this.anzahl} Inhaber/Geschäftsführer, von denen nur ${this.geschaeftsfuehrer.length === 1 ? 'einer' : this.geschaeftsfuehrer.length} im privaten Bereich versichert ${this.geschaeftsfuehrer.length === 1 ? 'wird' : 'werden'}. Wollen Sie dennoch fortfahren?`,
            { color: 'primary' }
          )
          .then(() => {
            this.$store.commit('gewerbeSetFilialenCount');
            this.$emit('step-forward');
          });
      } else {
        this.$store.commit('gewerbeSetFilialenCount');
        this.$emit('step-forward');
      }
    }
  }
};
</script>
